(function () {
    'use strict';
    angular.module('app').service('sessionTimeoutService', sessionTimeoutService);
    sessionTimeoutService.$inject = ['$http', '$localStorage', '$q', '$timeout', '$rootScope', '$injector', '$cookies', 'authService', 'clientService'];
    function sessionTimeoutService($http, $localStorage, $q, $timeout, $rootScope, $injector, $cookies, authService, clientService) {

        // Note: If last tab is closed, the signalR connection is broken and the server releases the licencse.

        // This service.
        var service = this;

        // Init debugging variables.
        service.enableSessionTimeOutDebugging = false;
        service.tickMessage = "";
        service.lastAction = "";
        service.bInHttpCall = false;

        // Called with true, as an outgoing HTTP call is made,
        // and with false when the call returns.
        // At this time we have not implemented this flag.
        $rootScope.inHttpCall = function (bInHttpCall) {
            $localStorage.bInHttpCall = bInHttpCall;
            service.bInHttpCall = bInHttpCall;
        }

        // Called by anyone that wants to update the last action.
        // In effect, resetting the timeout timer.
        $rootScope.lastAction = function () {
            // Stored in localStorage.
            var now = new Date();
            $localStorage.lastAction = now;
            service.lastAction = now; // For DEBUG.
        }

        // Make a fake guid.
        function guid() {
            function s4() {
                return Math.floor((1 + Math.random()) * 0x10000)
                  .toString(16)
                  .substring(1);
            }
            return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
              s4() + '-' + s4() + s4() + s4();
        }

        // Create a new tab item that is initialized.
        function newItem(tabId) {
            return { tabId: tabId, hasTimer: false, sessionTimeoutInterval: null, lastChanceInterval: null, watcherInterval: null, countdownMsgBoxActive: false, sessionTimedOut: false};
        }

        // Look in the tabs array for this tabId, or create it.
        function findOrCreateItem(tabId) {
            var foundItem = null;
            // If there is no array yet, ...
            if ($localStorage.tabs == null) {
                // Create the array.
                $localStorage.tabs = [];
                if ($localStorage.enableSessionTimeOutDebugging) console.log("*** SESSION TIMEOUT *** findOrCreateItem *** Created tab array.");
            }
            else { // Else, walk tabs, ...
                angular.forEach($localStorage.tabs, function (item) {
                    // If we found a match, remember it.
                    if (item.tabId == tabId)
                        foundItem = item;
                });
            }
            // If we did not found a match, ...
            if (foundItem == null) {
                // Make a new tab.
                foundItem = newItem(tabId);
                // Append an item to the array.
                var len = $localStorage.tabs.length;
                $localStorage.tabs[len] = foundItem;
                if ($localStorage.enableSessionTimeOutDebugging) console.log("*** SESSION TIMEOUT *** findOrCreateItem *** Adding tab item with tabId: " + tabId);
            }
            return foundItem;
        };

        // Stop the timers for one tab.
        function stopItem(item) {
            var $interval = $injector.get('$interval');
            if (item != null) {
                if (item.lastChanceInterval != null) {
                    $interval.cancel(item.lastChanceInterval);
                    item.lastChanceInterval = null;
                }
                if (item.sessionTimeoutInterval != null) {
                    $interval.cancel(item.sessionTimeoutInterval);
                    item.sessionTimeoutInterval = null;
                }
            }
        }

        // Stop all timers in all tabs.
        function stopAll() {
            var $interval = $injector.get('$interval');
            // If there are tabs, ...
            if ($localStorage.tabs != null) {
                // Walk the tabs, ...
                angular.forEach($localStorage.tabs, function (item) {
                    // Stop each one.
                    stopItem(item);
                });
            }
        };

        // Find or create my tabId.
        function getTabId() {
            var tabId = sessionStorage.tabId; // $rootScope.tabId;
            if (tabId == null) {
                tabId = guid();
                sessionStorage.tabId = tabId; // $rootScope.tabId = tabId;
                if ($localStorage.enableSessionTimeOutDebugging) console.log("*** SESSION TIMEOUT *** getTabId *** Generated tabId: " + tabId);
            }
            else {
                if ($localStorage.enableSessionTimeOutDebugging) console.log("*** SESSION TIMEOUT *** getTabId *** Found tabId: " + tabId);
            }
            return tabId;
        };

        // Called by the code that negotiates who takes over the main timer.
        function getRandomIntInclusive(min, max) {
            min = Math.ceil(min);
            max = Math.floor(max);
            return Math.floor(Math.random() * (max - min + 1)) + min; //The maximum is inclusive and the minimum is inclusive 
        }

        // Called by watcher and watcher countdown.
        // Sometimes countdown was detecting timed out and let the watch handle it, but it didn't.
        // So, have either do the whole shutdown.
        function onWatchSessionTimedOut(item) {
            // Get the interval object.
            var $interval = $injector.get('$interval');

            // Cancel watcher countdown.
            $interval.cancel(item.lastChanceInterval);
            item.lastChanceInterval = null;

            // Cancel watcher
            $interval.cancel(item.watcherInterval);
            item.watcherInterval = null;

            // Go to login screen.
            var $state = $injector.get('$state');
            $state.go("layout.logout");
        }

        // 3 second timer. Negotation timer of 5 to 8.
        function onWatcher(item) {
            // Get the interval object.
            var $interval = $injector.get('$interval');
            // Define some interval parameters.
            var msBetweenCalls = 3000;
            var numberOfTimesToRepeat = 0;
            // Start a watcher from the secondary tab.
            item.watcherInterval = $interval(function () {

                // Don't do this. 
                // Leave main watcher working because it checks for sessionTimedOut
                //if (item.lastChanceInterval != null && item.lastChanceInterval.$$intervalId != null)
                //    return;

                service.tickMessage = "watcher: " + new Date();

                // Get the last check by and the time.
                var lastCheckBy = $localStorage.lastCheckBy;
                var lastCheck = new Date($localStorage.lastCheck);
                var deadAtTime = new Date(lastCheck.getTime());
                // The 'assume main is dead' time is lastCheck + 2 minutes.
                deadAtTime.setSeconds(deadAtTime.getSeconds() + 60 + 60);
                var now = new Date();
                // If 'main is dead', ...
                if (deadAtTime < now) {
                    // Multi-secondary tab negotiation pause time between 1 and 5 seconds.
                    var randomIsItMyTurnTimeCheck = getRandomIntInclusive(5, 8);
                    // Call it.
                    $localStorage.lastCheck = new Date();
                    $localStorage.lastCheckBy = item.tabId;
                    $interval(function () {
                        // See if I am the winner.
                        var winner = $localStorage.lastCheckBy;
                        if (winner == item.tabId) {
                            // If I am the winner, stop my watcher, and start my mainTimer.
                            $interval.cancel(item.watcherInterval);
                            item.watcherInterval = null;
                            startMainTimer($localStorage.enableSessionTimeOut, $localStorage.sessionTimeOutMinutes, item);
                        }
                    }, randomIsItMyTurnTimeCheck * 1000, 1);
                }
                else {
                    if ($localStorage.sessionTimedOut) {
                        if ($localStorage.enableSessionTimeOutDebugging) console.log("*** SESSION TIMEOUT *** onWatcher *** Watcher detected session timeout.");
                        onWatchSessionTimedOut(item);
                    }
                    if ($localStorage.lastChanceStart != null) {
                        if (item.countdownMsgBoxActive == false) {
                            // Give the warning msg.
                            item.countdownMsgBoxActive = true;
                            // "You will be logged out in 60 seconds.", "Session Timeout"
                            var loginService = $injector.get('loginService');
                            var timeoutSecsMsg = loginService.resourceStrings["SESSION_TIMEOUT_SECONDS"];
                            timeoutSecsMsg = timeoutSecsMsg.replace("{0}", "60");
                            $rootScope.msgBoxShow(timeoutSecsMsg, loginService.resourceStrings["SESSION_TIMEOUT_TITLE_INSTRUCTION"]);
                            $localStorage.lastChanceMessage = $rootScope.msgBox.message;

                            var sameMessageCount = 0;
                            var lastMessage = "";

                            item.lastChanceInterval = $interval(function () {

                                // Close the watcher countdown so as not to interfere with watcher handling timed out.
                                if ($localStorage.sessionTimedOut) {
                                    if ($localStorage.enableSessionTimeOutDebugging) console.log("*** SESSION TIMEOUT *** onWatcher *** Watcher countdown detected session timeout.");
                                    onWatchSessionTimedOut(item);
                                }

                                service.tickMessage = "watcher countdown: " + new Date();

                                // Keep a count in case the main counter died.
                                if (lastMessage == $localStorage.lastChanceMessage)
                                    sameMessageCount = sameMessageCount + 1;
                                else {
                                    sameMessageCount = 0;
                                    lastMessage = $localStorage.lastChanceMessage
                                }

                                // If more than 3 seconds without an update, ...
                                if (sameMessageCount > 3) {
                                    // Cancel this countdown.
                                    $interval.cancel(item.lastChanceInterval);
                                    item.lastChanceInterval = null;
                                    // Cancel the message box.
                                    item.countdownMsgBoxActive = false;
                                    $rootScope.msgBox.visible = false;
                                    // Don't re-enter here.
                                    $localStorage.lastChanceStart = null;
                                    // Let the watcher interval pick up the slack later.
                                    return;
                                }

                                $rootScope.msgBox.message = $localStorage.lastChanceMessage;
                            }, 1000, 60);
                        }
                    }
                    else {
                        // Cancel the message box.
                        if (item.countdownMsgBoxActive == true) {
                            item.countdownMsgBoxActive = false;
                            $rootScope.msgBox.visible = false;
                        }
                    }
                }
            }, msBetweenCalls, numberOfTimesToRepeat);
        };

        // Called when this tab reloads.
        service.onLoad = function (bIsLoggedIn) {
            if ($localStorage.enableSessionTimeOutDebugging) console.log("*** SESSION TIMEOUT *** onLoad *** bIsLoggedIn: " + bIsLoggedIn);
            
            // For debugging, ...
            var bDbgClean = false;
            if (bDbgClean == true) {
                sessionStorage.removeItem("tabId");
                $localStorage.tabs = null;
            }
           
            // Get my tab and item.
            var tabId = getTabId();
            var item = findOrCreateItem(tabId);
            
            // If not logged in, then just make sure I don't have any timers.
            if (bIsLoggedIn == false) {
                if ($localStorage.enableSessionTimeOutDebugging) console.log("*** SESSION TIMEOUT *** onLoad *** not logged in. stopping.");
                // Not logged in, so shutdown my timers.
                stopItem(item);
            }
            else { // Already logged in and are now refreshing.
                
                // If timeouts are not enabled, stop my timers.
                if ($localStorage.enableSessionTimeOut == false) {
                    if ($localStorage.enableSessionTimeOutDebugging) console.log("*** SESSION TIMEOUT *** onLoad *** disabled. stopping.");
                    stopItem(item);
                }
                else {
                    // If I am the timer, ...
                    if (item.hasTimer) {
                        // Refresh the page is somehow setting the interval to {}. So, also check something internal.
                        if (item.sessionTimeoutInterval == null || item.sessionTimeoutInterval.$$intervalId == null) {
                            startMainTimer($localStorage.enableSessionTimeOut, $localStorage.sessionTimeOutMinutes, item);
                        }
                    }
                    else { // Else, I'm a watcher.
                        // Refresh the page is somehow setting the interval to {}. So, also check something internal.
                        if (item.watcherInterval == null || item.watcherInterval.$$intervalId == null) {
                            onWatcher(item);
                        }
                    }
                }
            }
        }

        // Called by onLogin, onLoad of the main tab, or from the watcher when it detects that it needs to take over the main timer.
        function startMainTimer(enableSessionTimeOut, sessionTimeOutMinutes, item) {

            if ($localStorage.enableSessionTimeOutDebugging) console.log("*** SESSION TIMEOUT *** startMainTimer");

            // Get the interval object.
            var $interval = $injector.get('$interval');

            // Define some interval parameters.
            var msBetweenCalls = 60 * 1000;
            var numberOfTimesToRepeat = 0;

            // Init.
            $localStorage.lastAction = new Date(); // OK to re-init an action on a main timer takeover because closing a tab is an action.
            $localStorage.bInHttpCall = false;
            $localStorage.lastChanceLastAction = null; // The last action when the last chance was triggered.
            $localStorage.lastChanceMessage = null; // The message that shows the countdown.
            $localStorage.lastChanceStart = null; // The time that the last chance was triggered.
            $localStorage.lastCheck = new Date(); // The last time that the main timer fired.
            $localStorage.lastCheckBy = item.tabId; // The tabId of the tab that did the lastCheck.
            $localStorage.sessionTimedOut = false; // Clear the flag that says we have been timed out.

            // Is timeout enabled?
            if (enableSessionTimeOut) {
                if ($localStorage.enableSessionTimeOutDebugging) console.log("*** SESSION TIMEOUT *** startMainTimer *** Enable Session Timeout for " + sessionTimeOutMinutes + " minutes.");
                service.tickMessage = "session: " + new Date();

                // This tab has the timer.
                item.hasTimer = true;

                // Start the main tab timer.
                item.sessionTimeoutInterval = $interval(function () {

                    service.tickMessage = "session: " + new Date();

                    // Update last check.
                    $localStorage.lastCheck = new Date();
                    $localStorage.lastCheckBy = item.tabId;

                    // If the last chance is active, return;
                    if (item.lastChanceInterval != null)
                        return;

                    if ($localStorage.enableSessionTimeOutDebugging) console.log("*** SESSION TIMEOUT *** mainTimer *** Checking Session Timeout");

                    // The timeout date is the ... date of the last action + the number of minutes until the timeout.
                    var timeOutDate = new Date($localStorage.lastAction);
                    timeOutDate.setMinutes(timeOutDate.getMinutes() + sessionTimeOutMinutes);
                    var now = new Date();

                    var bLocalStorageSaysInCall = $localStorage.bInHttpCall == "true";

                    // If the timeout date has already passed (is less than now), ...
                    if (timeOutDate < now && !bLocalStorageSaysInCall) {
                        // Store a copy of the last action.
                        $localStorage.lastChanceLastAction = new Date($localStorage.lastAction);
                        // Store a copy of the last chance start.
                        $localStorage.lastChanceStart = new Date(now.getTime());
                        // Give the warning msg.
                        item.countdownMsgBoxActive = true;
                        // "You will be logged out in 60 seconds.", "Session Timeout"
                        var loginService = $injector.get('loginService');
                        var timeoutSecsMsg = loginService.resourceStrings["SESSION_TIMEOUT_SECONDS"];
                        timeoutSecsMsg = timeoutSecsMsg.replace("{0}", "60");
                        $rootScope.msgBoxShow(timeoutSecsMsg, loginService.resourceStrings["SESSION_TIMEOUT_TITLE_INSTRUCTION"]);
                        // Start a 1 second tick timer and store it so the outer timer won't step on us.
                        item.lastChanceInterval = $interval(function () {

                            service.tickMessage = "session countdown: " + new Date();

                            // Update last check.
                            $localStorage.lastCheck = new Date();
                            $localStorage.lastCheckBy = item.tabId;

                            var lastAction = new Date($localStorage.lastAction);
                            var lastChanceLastAction = new Date($localStorage.lastChanceLastAction);

                            var sLastAction = ("" + lastAction.getHours() + ":" + lastAction.getMinutes() + ":" + lastAction.getSeconds());
                            var sLastChanceLastAction = ("" + lastChanceLastAction.getHours() + ":" + lastChanceLastAction.getMinutes() + ":" + lastChanceLastAction.getSeconds());
                            var sBreakCompare = "LastAction: " + sLastAction + ", LastChanceLastAction: " + sLastChanceLastAction;
                            if ($localStorage.enableSessionTimeOutDebugging) console.log("*** SESSION TIMEOUT *** mainLastChanceTimer" + sBreakCompare);

                            // If the current last action is not the same as it was when we started the last chance.
                            //if ($localStorage.lastAction != $localStorage.lastChanceLastAction) {
                            if (sLastAction != sLastChanceLastAction) {
                                // Cancel the message box.
                                if (item.countdownMsgBoxActive == true) {
                                    item.countdownMsgBoxActive = false;
                                    $rootScope.msgBox.visible = false;
                                }

                                // Clear last chance info.
                                $localStorage.lastChanceLastAction = null;
                                $localStorage.lastChanceStart = null;
                                $localStorage.lastChanceMessage = "";

                                // Cancel this interval and return.
                                $interval.cancel(item.lastChanceInterval);
                                item.lastChanceInterval = null;
                                return;
                            }

                            // Get a string of the last chance start.
                            var lastChanceStart = new Date($localStorage.lastChanceStart);
                            var sLastChanceStart = ("" + lastChanceStart.getHours() + ":" + lastChanceStart.getMinutes() + ":" + lastChanceStart.getSeconds());

                            // Calc when the last chance runs out and a string for it.
                            var lastChanceStop = new Date($localStorage.lastChanceStart); //.getTime()
                            lastChanceStop.setSeconds(lastChanceStop.getSeconds() + 60);
                            var sLastChanceStop = ("" + lastChanceStop.getHours() + ":" + lastChanceStop.getMinutes() + ":" + lastChanceStop.getSeconds());

                            // Get now and a string for it.
                            var now = new Date();
                            var sNow = ("" + now.getHours() + ":" + now.getMinutes() + ":" + now.getSeconds());

                            // Write out the countdown.
                            var msg = "LastChanceStart: " + sLastChanceStart + ", LastChanceStop: " + sLastChanceStop + ", Now: " + sNow;
                            //console.log(msg);

                            // Update message box.
                            var loginService = $injector.get('loginService');
                            var secondsUntilLogout = Math.round(Math.abs((now.getTime() - lastChanceStop.getTime()) / 1000));
                            if (secondsUntilLogout != 1) {
                                timeoutSecsMsg = loginService.resourceStrings["SESSION_TIMEOUT_SECONDS"];
                                timeoutSecsMsg = timeoutSecsMsg.replace("{0}", secondsUntilLogout);
                                $rootScope.msgBox.message = timeoutSecsMsg;
                            }
                            else {
                                timeoutSecsMsg = loginService.resourceStrings["SESSION_TIMEOUT_SECOND"];
                                $rootScope.msgBox.message = timeoutSecsMsg;
                            }
                            // Update localStorage so other tabs can update their msgboxes.
                            $localStorage.lastChanceMessage = $rootScope.msgBox.message;

                            // If the last chance has passed, ...
                            if (lastChanceStop < now) {
                                // Stop my timers.
                                stopItem(item);
                                // Set the localStorage flag.
                                $localStorage.sessionTimedOut = true;
                                // Logout.
                                var loginService = $injector.get('loginService');
                                loginService.logOut();
                                // Go to the login page.
                                var $state = $injector.get('$state');
                                $state.go("layout.logout");
                            }
                        }, 1000);
                    }
                }, msBetweenCalls, numberOfTimesToRepeat);
            }
        }

        // Called when the user logs in from this tab.
        service.onLogin = function (enableSessionTimeOut, enableSessionTimeOutDebugging, sessionTimeOutMinutes) {
            // Stop all timers/intervals
            stopAll();
            // Clear all tabs from local storage.
            $localStorage.tabs = null;

            // Remember if we are debugging.
            service.enableSessionTimeOutDebugging = enableSessionTimeOutDebugging;

            // Remember timeout settings in local storage so other tabs can read them.
            $localStorage.enableSessionTimeOut = enableSessionTimeOut;
            $localStorage.enableSessionTimeOutDebugging = enableSessionTimeOutDebugging;
            $localStorage.sessionTimeOutMinutes = sessionTimeOutMinutes;
            // Clear the flag that says we have been timed out.
            // CLEANUP - UNNEC??? $localStorage.sessionTimedOut = false;

            // Get my tab and item.
            var tabId = getTabId();
            var item = findOrCreateItem(tabId);

            // I'm am the tab logging in, so start the main timer.
            startMainTimer(enableSessionTimeOut, sessionTimeOutMinutes, item);
        };


        // Called when the user logs out, or has been logged out.
        service.onLogout = function () {
            if ($localStorage.enableSessionTimeOutDebugging) console.log("*** SESSION TIMEOUT *** onLogOut");
            // Get my tab and item.
            var tabId = getTabId();
            var item = findOrCreateItem(tabId);
            // Stop my timers/intervals.
            stopItem(item);
            // Clear the debug message.
            service.tickMessage = "";
        };

        // Called when the login page loads. 
        // Returns true if the user has been logged out.
        service.checkForTimedOut = function (msgBox) {
            if (service.enableSessionTimeOutDebugging) console.log("*** SESSION TIMEOUT *** checkForTimedOut *** localStorage.sessionTimedOut: " + $localStorage.sessionTimedOut);
            // If localStorage says we have timed out, ...
            if ($localStorage.sessionTimedOut === true) {
                // Move the localStorage timeout to each tab. Then remove the localStorage timeout.
                angular.forEach($localStorage.tabs, function (item) {
                    item.sessionTimedOut = true;
                });
                $localStorage.sessionTimedOut = false;
                return true;
            }
            else { // Otherwise, check our tab info.
                if ($localStorage.enableSessionTimeOutDebugging) console.log("*** SESSION TIMEOUT *** checkForTimedOut *** looking for item");
                // Get my tab and item.
                var tabId = getTabId();
                var item = findOrCreateItem(tabId);
                if ($localStorage.enableSessionTimeOutDebugging) console.log("*** SESSION TIMEOUT *** checkForTimedOut *** item timeout: " + item.sessionTimedOut);
                // See if our tab has the flag set.
                if (item.sessionTimedOut === true) { 
                    return true;
                }
            }
            return false;
        }

    };
})();